import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from '../main/app.main.component';
import { SwitchApp, SwitchAppItem } from 'src/app/shared/models/enum/switchApp.model';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
import { AuthenticationService } from '../login/authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { getAppVersion } from 'src/app/shared/constants/app-version';
declare function OpenLink(url): any;


@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[];
    switchApp: string;

    switchAppItems: SwitchAppItem[];
    itemTest = { label: 'Test', icon: 'fa-solid fa-flask-vial fa-fw ', routerLink: ['/test/xamarinfunctions'] };

    get version(): string {
        return getAppVersion();
    }

    constructor(public app: AppMainComponent, public appCom: AppComponent,
        private router: Router,
        public auth: AuthenticationService) { }

    ngOnInit() {
        this.subMenu();
        this.switchAppItems = [
            SwitchApp.CONDUCTORES,
            SwitchApp.TAXIS
        ];
    }

    subMenu() {
        this.appCom.switchApp.subscribe(res => {
            this.getMenu(res);
            this.switchApp = res.toString();
        });
    }

    getMenu(app) {
        switch (app) {
            case SwitchApp.CONDUCTORES:
                this.setMenuConductores();
                break;
            case SwitchApp.TAXIS:
                this.setMenuTaxis();
                break;
            default:
                this.setMenuConductores();
                break;
        }
        if (!environment.production) {
            this.model.push(this.itemTest);
        }
    }


    setMenuConductores() {
        this.model = [
            { label: 'Servicios', icon: 'fa-solid fa-fw fa-list', routerLink: ['/conductores/listado-servicios'] },
            { label: 'Anomalías', icon: 'fa-solid fa-fw fa-screwdriver-wrench', routerLink: ['/conductores/anomalias'] },
            { label: 'Mensajería', icon: 'fa-regular fa-fw fa-envelope', routerLink: ['/conductores/mensajeria'] },
            { label: 'Manual conductores', icon: 'fa-solid fa-fw fa-circle-info', command: () => OpenLink("https://softour.sharepoint.com/:b:/s/softour/EeQfj6NZlAdAtWUQz_FZIBcBC7gunSToi3NcJ44v7AnJjg?e=0foRsp") },
            // { label: 'Test', icon: 'fa-solid fa-flask-vial fa-fw ', routerLink: ['/test/xamarinfunctions'] }

        ];
    }

    setMenuTaxis() {
        this.model = [
            { label: 'Nuevo', icon: 'fa-solid fa-fw fa-plus', routerLink: ['/taxis/form'] },
            { label: 'Pendientes', icon: 'fa-solid fa-fw fa-list', routerLink: ['/taxis/pendientes'] },
            { label: 'Manual Taxis', icon: 'fa-solid fa-fw fa-circle-info', command: () => OpenLink("https://softour.sharepoint.com/:b:/s/softour/EQmJWkYVjgxHqtQJZyYs-RoBKYDKqTcrP_t6FMItRREaag?e=lffq85") },

            // { label: 'Test', icon: 'fa-solid fa-flask-vial fa-fw ', routerLink: ['/test/xamarinfunctions'] }
        ]
    }

    switchImage(app: string): string {
        return `assets/layout/images/apps/${app}.svg`
    }

    onMenuClick(event) {
        this.app.onMenuClick(event);
    }

    onClickSwitchApp(switchapp: SwitchAppItem) {
        this.appCom.changeSwitchApp(switchapp);
        this.router.navigate([switchapp.iniroute]);
        this.app.onLayoutClick();
    }
}

